<template>
  <div>
    <!-- 搜索条件 -->
    <div class="search clear">
      <el-form :inline="true" size="mini">
        <el-form-item label="标签名称">
          <el-input placeholder="标签名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select style="width:100px;" clearable>
            <el-option label="有效" value="1"></el-option>
            <el-option label="无效" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否推荐">
          <el-select style="width:100px;" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button type="success" @click="add">添加标签</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        size="small"
        height="100%"
        border
        style="width: 100%; height:100%;"
      >
        <el-table-column prop="name" label="标签名称"></el-table-column>
        <el-table-column prop="searchCount" label="搜索次数"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column prop="isComment" label="是否推荐"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >编辑</el-button>
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="prev, pager, next, total" :total="1000"></el-pagination>
    </div>

    <!-- 表单内容 -->
    <el-dialog class="dialog" :title="dialogTitle" :visible.sync="formVisible" width="40%">
      <TagForm></TagForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { tableData } from "../../../demo/art/tagslist";
import TagForm from "./components/TagForm";
export default {
  name: "art_tagslist",
  components: {
    TagForm
  },
  data() {
    return {
      tableData,
      formVisible: false,
      dialogTitle: "添加标签"
    };
  },
  methods: {
    //   添加
    add() {
      this.formVisible = true;
    }
  }
};
</script>

<style scoped>
</style>